export default "__VITE_ASSET__BZtWMbsB__"